'use client'

import * as React from 'react'
import * as SeparatorPrimitive from '@radix-ui/react-separator'

import { cn } from '@/lib/utils'
function Separator({ className, text }: { className: string; text?: string }) {
  return (
    <div className="flex items-center w-full my-4">
      <SeparatorPrimitive.Root decorative orientation="horizontal" className={cn('bg-gray-300 h-px flex-grow', className)} />
      {text && <span className="px-4 text-sm text-gray-500">{text || ''}</span>}
      <SeparatorPrimitive.Root decorative orientation="horizontal" className={cn('bg-gray-300 h-px flex-grow', className)} />
    </div>
  )
}

export { Separator }
